import { takeLatest, call, all, takeEvery, fork } from 'redux-saga/effects';
import browserHistory from 'history/browser';
import { router } from '@onegini/redux-saga-router';

import { jsToURICompactTransform } from '../../common/Services/AjaxService';

function* navigate({ payload }) {
  const { baseRoute, path = '', queryParams } = payload;
  yield call(
    browserHistory.push,
    `${baseRoute}${path}${!!queryParams ? `?${jsToURICompactTransform(queryParams, true)}` : ''}`
  );
}

function* navigateReplace({ payload }) {
  const { baseRoute, path = '', queryParams } = payload;
  yield call(
    browserHistory.replace,
    `${baseRoute}${path}${!!queryParams ? `?${jsToURICompactTransform(queryParams, true)}` : ''}`
  );
}

function* navigateReload() {
  yield call(browserHistory.replace, `${window.location.pathname}${window.location.search}`);
}

export default function* navigatorSaga() {
  yield all([
    takeEvery((action) => action.meta && action.meta.type === 'NAVIGATE', navigate),
    takeLatest((action) => action.meta && action.meta.type === 'NAVIGATE_REPLACE', navigateReplace),
    takeLatest((action) => action.meta && action.meta.type === 'NAVIGATE_RELOAD', navigateReload),
  ]);

  yield fork(router, browserHistory, {});
}
